import { checkIsAgent, checkIsPerformer } from "shared-auth";
import { usePublicView } from "pages/Profile/hooks/usePublicView";

export const useIsUserEditable = () => {
  const { isPublicView } = usePublicView();

  return (checkIsAgent() || checkIsPerformer()) && !isPublicView;
};
